export default {"src":"/_next/static/media/job.f9de1a96.svg","height":80,"width":83,"blurWidth":0,"blurHeight":0};